const toolsCartGoodsBuy = {
    getGoods: function (type = 'header_cart') {
        let goods = [];
        if (type == 'header_cart') {
            $('.block_add_cart .js__cart_buy_good').each(function () {
                const input = $(this);
                if (input.is(':checked')) {
                    goods.push(input.val());

                    const garantyInput = input.closest('.js__type_cart').find('.js__garanty_cart');
                    if (garantyInput.length > 0 && garantyInput.is(':checked')) {
                        goods.push(garantyInput.attr('data-guid') + '_' + garantyInput.attr('data-id_good'));
                    }
                }
            });
        } else {
            $('.mini_cart_wrapper_checkout .mini_cart_item_checkout').each(function () {
                const goodId = $(this).find('input[name=good_id]').val();
                const garantyGuid = $(this).find('input[name=garanty_guid]');
                const garantyGuidId = $(this).find('input[name=garanty_good_id]');

                goods.push(goodId);

                if (garantyGuid.length > 0 && garantyGuidId.length > 0) {
                    goods.push(garantyGuid.val() + '_' + garantyGuidId.val());
                }
            });
        }
        return goods.length > 0 ? goods : 'none';
    },

    updateActivePositionGoods: function (btn = false) {
        let isActive = 'list';
        if (btn) {
            isActive = btn.is(':checked') ? true : false;
        }

        $.post(request.updateByOleg, {
            "cart_good_guids": toolsCartGoodsBuy.getGoods(),
        }, function (data) {
            if (data.status == 'ok') {
                $('.js__all_active').attr('data-type_active', data.data.cart_quantity == data.data.cart_quantity_total ? 'all' : 'not_all');
                $('.js__all_active .js__all_good_to_cart').empty().text(data.data.cart_quantity_total);
                $('.js__all_active .js__all_good_active_to_cart').empty().text(data.data.cart_quantity);

                $('.cart_header .total_info .count, .cart_model_checkout .total_info .count').text(data.data.cart_quantity);
                $('.cart_header .total_info .price span, .cart_model_checkout .total_info .price span').text(data.data.cart_total);
                $('.js__quantity').text(data.data.cart_quantity);

                if ($('.js__main_page_info').length > 0) {
                    $('.js__main_page_info .main_page_user_tool_bar_text span').text(data.data.cart_total);
                }

                if (data.data.cart_total != 0 && Number(data.data.cart_total.split(' ').join('')) > 0) {
                    $('.cart_header .total_info .price').show();
                }

                if ($('.js__append_mini_cart').length > 0 && typeof data.data.html_mini_cart != 'undefined') {
                    $('.js__append_mini_cart').empty().append(data.data.html_mini_cart);
                }

                if ($('.js__send_checkout').length > 0) {
                    $('.js__open_mini_cart span').empty().text(data.data.cart_quantity);
                    $('.js__update_quantity').empty().text(data.data.cart_quantity_text);
                    $('.js__update_total_sum').empty().text(data.data.cart_total);
                    $('.js__update_total_sum[data-total]').attr('data-total', data.data.cart_total.replace(/\s+/g, ''))

                    checkoutTools.updateTotalPrice();
                }

                if (data.data.cart_quantity_total == 0) {
                    $('.block_add_cart').addClass('hide');
                    $('.cart_empty.header_cart').removeClass('hide');
                }

                if (isActive == 'list') {
                    $('.block_add_cart .js__cart_buy_good').each(function () {
                        const garantyGoodCart = $(this).closest('.js__type_cart').find('.garanty_good_cart');
                        const quantityGoodCart = $(this).closest('.js__type_cart').find('.quantity_good');

                        if ($(this).is(':checked')) {
                            garantyGoodCart.show();
                            quantityGoodCart.show();
                        } else {
                            garantyGoodCart.hide();
                            quantityGoodCart.hide();
                        }
                    })
                } else {
                    const garantyGoodCart = btn.closest('.js__type_cart').find('.garanty_good_cart');
                    const quantityGoodCart = btn.closest('.js__type_cart').find('.quantity_good');

                    if (isActive) {
                        garantyGoodCart.show();
                        quantityGoodCart.show();
                    } else {
                        garantyGoodCart.hide();
                        quantityGoodCart.hide();
                    }
                }
            }
        })
    }
}

$(document).ready(function () {
    $(document).on('click', '.js__cart_buy_good', function () {
        toolsCartGoodsBuy.updateActivePositionGoods($(this));
    })

    $(document).on('click', '.js__all_active', function () {
        const btn = $(this);
        const typeActive = btn.attr('data-type_active');

        typeActive == 'all' ? btn.attr('data-type_active', 'not_all') : btn.attr('data-type_active', 'all');
        btn.closest('.block_add_cart').find('.js__cart_buy_good').prop('checked', typeActive == 'all' ? false : true);

        toolsCartGoodsBuy.updateActivePositionGoods();
    })

    $(document).on('click', '.js__all_remove', function () {
        const btn = $(this);
        btn.closest('.block_add_cart').find('.js__delete_good_cart').trigger('click')
    })
})

window.toolsCartGoodsBuy = toolsCartGoodsBuy;